import React, { useEffect, useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
import {
  AutoComplete,
  Button,
  Checkbox,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Select,
  Switch,
} from "antd";
const style = {
  style: {
    minWidth: 200,
    maxWidth: 600,
  },
};

export const ItemRender = ({ props, keyItem }) => {

  const input = {
    checkbox: <Checkbox key={keyItem} {...style} onChange={props.onChange} checked={!!props.checked} />,
    text: <Input key={keyItem} {...style} placeholder={props?.placeholder} />,
    button: <Button {...style} />,
    password: <Input.Password key={keyItem} {...style} />,
    number: (
      <InputNumber
        key={keyItem}
        {...style}
        style={{ width: "100%" }}
        // min y max solo si están definidos
        {...(props.min !== undefined ? { min: props.min } : {})}
        {...(props.max !== undefined ? { max: props.max } : {})}
        disabled={props.disabled ?? false}
        controls={props.controls ?? false}
      />
    ),
    select: <Select key={keyItem} 
        showSearch
        allowClear
        filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
        options={props.opciones ?? []}
        onChange={props.onChange}
        placeholder="Selecciona opciones"/>,
    switch: <Switch key={keyItem} />,
    autocomplete: (
      <AutoComplete
        key={keyItem}
        {...style}
        allowClear
        options={props.opciones ?? []}
        placeholder={props.placeholder ?? "Escribe para buscar..."}
        onChange={props.onChange}
        disabled={props.disabled ?? false}
        value={props.value ?? null}
        filterOption={(inputValue, option) =>
          option?.label?.toLowerCase().includes(inputValue.toLowerCase())
        }
      />
    ),
    date: <DatePicker key={keyItem} {...style} />,
    multiple: (
      <Select
        key={keyItem}
        mode="multiple"
        allowClear
        filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
        options={props.opciones ?? []}
        onChange={props.onChange}
        placeholder="Selecciona opciones"

      />
    )

  };

  return (
    props && (
      <Form.Item
        key={keyItem}
        name={props.name}
        label={props.label ?? ""}
        rules={props.rules}
        hidden={props.hidden ?? false}
        extra={props.extra ?? ""}
        initialValue={props.defaultValue}
        shouldUpdate={props.shouldUpdate ?? false}
        valuePropName={props.valuePropName ?? "value"}
      >
        {input[props.type]}
      </Form.Item>
    )
  );
};
